import React, { useState } from 'react';
import GoogleButton from 'react-google-button';
import { BASE_URL } from '../config';

const Login = () => {
  const [error, setError] = useState('');

  const handleGoogleLogin = async () => {
    try {
      const response = await fetch(`${BASE_URL}/auth/google/login`);
      const data = await response.json();
      
      // Redirect to Google OAuth URL
      window.location.href = data.url;
    } catch (error) {
      console.error('Error initiating Google login:', error);
      setError('Failed to connect to authentication service. Please try again later.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to API Portal
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Access your API keys and API documentation
          </p>
        </div>
        
        {error && (
          <div className="p-3 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        )}
        
        <div className="mt-8 flex justify-center">
          <GoogleButton onClick={handleGoogleLogin} />
        </div>
        
        <div className="mt-4 text-center text-sm text-gray-600">
          <p>By signing in, you'll be able to view your API key and access our API documentation.</p>
        </div>
      </div>
    </div>
  );
};

export default Login; 